import { computed } from "vue"
import { ref, watch } from "vue"

/**
 * Creates a watch which can be ignored on command
 * 
 * @param {MultiWatchSources} value
 * @param {Function}          callback 
 * @param {WatchOptions}      watchOptions
 * @returns {Object}
 */
export default function useIgnorableWatch(value, callback, watchOptions) {

    /**
     * Force ignore all updates
     */
    const ignored = ref(false)

    /**
     * We need an array of all currently ignored requests
     * So we can keep calling the without function without any updates running until all are complete
     */
    const backedIgnore = ref([])

    /**
     * Internal: used to check if the watch should be ignored for any reason
     */
    const _ignored = computed(() => backedIgnore.value.length > 0 || ignored.value)


    return {
        ignored : ignored,
        watch   : watch(
            value, 
            (updated, original) => {
                if(!_ignored.value){
                    callback(updated, original)
                }
            },
            watchOptions
        ),

        /**
         * Runs a callback without triggering the associated watch
         * 
         * @param {Function} callback 
         */
        without: async (callback) => {
            const ignoreIdentifier = Symbol() //symbols are globally unique, allows us to make sure we only remove our current instance

            backedIgnore.value.push(ignoreIdentifier)

            await callback()

            const ignoreIndex = backedIgnore.value.indexOf(ignoreIdentifier)
            if(ignoreIndex !== -1){
                backedIgnore.value.splice(ignoreIndex, 1)
            }
        }
    }
}